import type { FaireProductEntity } from "../../entity_types/product";

export const p_8jgkf4b8w7: FaireProductEntity = {
  token: "p_8jgkf4b8w7",
  type: "product",
  name: "ONYX CHECKS TODDLER BEANIE",
  brandToken: "b_n5qta5twp3",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/ec0500e3a466c07eb5eafd8deed923c47c157a2b60e3009b2c468abbc6b0c0d8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/125e56cb363e71173fef3c89da616cdaa47f036e8c6f16092dac92cdb34a2e18.jpeg",
    "https://cdn.faire.com/fastly/2780a3f9a3f1459245f53b815a53c2be9b1ae02b7b473665e41d385454a16cd1.jpeg",
    "https://cdn.faire.com/fastly/7dd8d3265aaed5c97f9a92125a51bdef7cb9f794d4fe752601e634973ed5e373.jpeg",
  ],
  priceDollars: 18.29,
  description:
    "Meet the Onyx Checkers toddler beanie A bold, classic pattern in black and white makes this beanie a standout piece for little ones. Soft, cozy, and built to last, it’s perfect for chilly days, layering, or adding a touch of style to any outfit.\n",
  tags: [],
  msrpDollars: 36.58,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:24:56.164Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
